module.exports = __webpack_public_path__ + "img/plus-logo.01355853.webp";